import { render, staticRenderFns } from "./SectionHero.vue?vue&type=template&id=2bf9d19f&"
import script from "./SectionHero.vue?vue&type=script&lang=js&"
export * from "./SectionHero.vue?vue&type=script&lang=js&"
import style0 from "./SectionHero.vue?vue&type=style&index=0&id=2bf9d19f&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports